import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["connectExistingReceipt", "connectExistingReceiptLink", "chooseAmongUnmatched", "chooseAmongUnmatchedRadio", "chooseAmongLatest100"];
  static formElementsForToggling = 'input, select, textarea, button'

  connect() {
    if(this.hasChooseAmongUnmatchedRadioTarget) { this.chooseAmongUnmatchedRadioTarget.click(); }
  }

  prepareUpload(event) {
    var clickedLabel = event.target.closest('label');
    var realFormInput = document.getElementById(clickedLabel.getAttribute('for'));
    if(realFormInput) {
      var uploadForm = realFormInput.form;
      var rowIdHidden = document.createElement("input");
      rowIdHidden.type = "hidden";
      rowIdHidden.value = clickedLabel.dataset.bankRowId;
      rowIdHidden.name = "bank_row_id";
      // Since this label points to another form, it doesn't get the spinner automatically, so we have to add it manually.
      uploadForm.addEventListener('submit', function(event) { 
        clickedLabel.classList.add('spinner');
      });
      uploadForm.appendChild(rowIdHidden);
      // We need to make the form a remote form, since we want to make an ajax call
      uploadForm.dataset.remote = 'true';
    }
  }

  connectExistingReceipt(event) {
    const payment_matchable_id = this.findActiveReceiptSelect().value;
    this.connectExistingReceiptLinkTarget.href = this.connectExistingReceiptLinkTarget.href + "&payment_matchable_id=" + payment_matchable_id;
    // This is the WIP modal version of connect existing, see same commit for the rest
    //document.body.click(); // Close modal if we're doing the modal version
  }

  findActiveReceiptSelect() {
    return this.connectExistingReceiptTargets.find(select_elem => select_elem.disabled == false)
  }

  hideAndDisableFormInputs(container) {
    container.classList.add("hidden");
    const formElements = container.querySelectorAll(this.constructor.formElementsForToggling);
    formElements.forEach((element) => { element.disabled = true; });
  }

  showAndEnableFormInputs(container) {
    container.classList.remove("hidden");
    const formElements = container.querySelectorAll(this.constructor.formElementsForToggling);
    formElements.forEach((element) => { element.disabled = false; });
  }

  chooseAmongUnmatched(event) {
    this.hideAndDisableFormInputs(this.chooseAmongLatest100Target);
    this.showAndEnableFormInputs(this.chooseAmongUnmatchedTarget);
  }

  chooseAmongLatest100(event) {
    this.hideAndDisableFormInputs(this.chooseAmongUnmatchedTarget);
    this.showAndEnableFormInputs(this.chooseAmongLatest100Target);
  }
}